import styled, { keyframes } from "styled-components";

import bgImg from "../../../assets/senai-fundo.jpg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Mensagem = styled.article`

  animation: ${fadeIn} 0.5s;

  z-index: 9;

  >h1{
    text-shadow: 0px 2px 5px white;
    font-size: 42px;
  }
  
`;
